import { Stack } from '@mui/material'
import { useTheme } from '@emotion/react'

const CalendarEventItem = ({ event }) => {
  const theme = useTheme()

  const isForecast = event.extendedProps.forecast

  const eventPixelWidth = isForecast ? 5 : 10

  return (

    <Stack
      sx={{
        height: '3rem',
        overflowX: 'hidden',
        background:
               !event.extendedProps.systemDefault
                 ? 'repeating-linear-gradient(45deg, ' + theme.palette.error.dark + ', ' + theme.palette.error.dark + ' ' + eventPixelWidth + 'px, ' + theme.palette.error.main + ' ' + eventPixelWidth + 'px, ' + theme.palette.error.main + ' 20px)'
                 : 'repeating-linear-gradient(45deg, ' + theme.palette.calendar.systemDefault + ', ' + theme.palette.calendar.systemDefault + ' 10px, ' + theme.palette.error.main + ' 10px, ' + theme.palette.error.main + ' 20px)'
      }}
      direction='row'
      justifyContent='center'
    />

  )
}

export default CalendarEventItem
